import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-secondary-card',
  templateUrl: './secondary-card.component.html',
  styleUrls: ['./secondary-card.component.scss'],
})
export class SecondaryCardComponent implements OnInit {
  @Input() text = '';
  @Input() textClasses = '';
  @Input() cardClasses = '';
  @Input() imgPath = '';
  @Input() imgClasses = '';
  @Input() imgBlockClasses = '';
  @Input() text_button = '';
  @Input() buttonClasses = '';
  @Output() IsClicked = new EventEmitter<any>();
  constructor() {}

  ngOnInit(): void {}

  onClick($event: any): void {
    this.IsClicked.emit($event);
  }
}
